module.exports = __webpack_public_path__ + "assets/img/info-btn-0bc0a116.png";